import React from 'react'

import { Flex, Text } from 'components/ds'

import styles from './index.module.css'

export const SearchResultsSource: React.FC = () => (
  <Flex pl="1" pb="1">
    <Text size="1" className={styles.sourceText}>
      Results provided by AIMS
    </Text>
  </Flex>
)
